import { WORKBAR_ACTIONS, PREVIEW_TRANSFER, DRAGGABLE_WINDOWS } from '../../constants.js';
import { SingletonSharedData } from '../singletonSharedData';
import SingletonWebSocket from '../Singletons/SingletonWebSocket'
import { Logger } from '../../js/helpers/Logger';
import { alertQueryErrorBody } from '../alertQueryErrorBody.js';

const sharedData = new SingletonSharedData();

export const STRATEGIES_API_RESPONSE = {
  "CallOutCampaigns": function (message, that) {
    let json = JSON.parse(message.Json);

    sharedData.setCallOutCampaigns(json.Response);
    if (message.StatusCode === 500) {
      Logger.Trace("[Strategies_Api_Response][CallOutCampaigns] Campaigns =>", message);
      const type = json.Type;
      const code = json.InternalCode
      const error = that.language.getText(`${type.toLowerCase()}-${code}`);
      Logger.Error("[Strategies_Api_Response][CallOutCampaigns] Error consulting data base =>", error);
      const integrationMessage = { client: "galatea", data: { code, message: error }, action: "errorOnCampaignsRelated" };
      SingletonWebSocket.send(integrationMessage);

    }

    that.props.updateInfoWB(WORKBAR_ACTIONS.MANUAL_CALL);
  },
  "SaveDispositionListACD": function (message, that) {
    Logger.Trace("[Strategies_Api_Response][SaveDispositionListACD] SaveDispositionListACD");
    let json = JSON.parse(message.Json);
    if (message.StatusCode === 500) {
      Logger.Warning("[Strategies_Api_Response][SaveDispositionListACD] Error saving Disposition List ACD");
      const type = json.Type;
      const code = json.InternalCode
      const error = that.language.getText(`${type.toLowerCase()}-${code}`);
      const data = { code, message: error };
      const integrationMessage = SingletonWebSocket.getJson("Disposition", "errorOnDispose", data);
      SingletonWebSocket.send(integrationMessage);      
    }
    else {
      Logger.Trace("[Strategies_Api_Response][SaveDispositionListACD] Successed disposition");
      const integrationMessage = SingletonWebSocket.getJson("Disposition", "onDisposeApplied", "");
      SingletonWebSocket.send(integrationMessage);
    }
  },
  "TransferCallData": function(message, that){
    Logger.Trace("[Strategies_Api_Response][TransferCallData] TransferCallData");
    let json = JSON.parse(message.Json);
    if(message.StatusCode === 500){
      Logger.Warning("[Strategies_Api_Response][TransferCallData] Error consulting data base");
      that.props.showAlertModal(alertQueryErrorBody());
      this.props.removeWindow(DRAGGABLE_WINDOWS.TRANSFER_CALL);
    }
    else{
      Logger.Trace("[Strategies_Api_Response][TransferCallData] Successed");
      that.props.dataTransferPreview(PREVIEW_TRANSFER.DATA_CALL_PREVIEW,json.Response.TelefonosList, json.Response.AcdList, json.Response.AgentesList);
    }
  },
  "UpdateCallKey": function(message, that){
    Logger.Trace("[Strategies_Api_Response][UpdateCallKey] UpdateCallKey");
    if(message.StatusCode === 500){
      Logger.Warning("[Strategies_Api_Response][UpdateCallKey] Error consulting data base");
    }
    else{
      Logger.Trace("[Strategies_Api_Response][UpdateCallKey] Successed");
    }
  },
  "SelectAniManualCall": function (message, that) {
    let json = JSON.parse(message.Json);
    if (message.StatusCode === 200) {
      Logger.Trace("[Strategies_Api_Response][SelectAniManualCall] ANIList =>", message);
      sharedData.setANIListCampaign(json.Response)
      sharedData.setIsANIListEmpty(false);
    }else if(message.StatusCode === 204){
      Logger.Trace("[Strategies_Api_Response][SelectAniManualCall] ANIList =>", message);
      sharedData.setANIListCampaign([]);
      sharedData.setIsANIListEmpty(true);
    }
  },
  "GetRecordCallPermission": function (message, that) {
    let json = JSON.parse(message.Json);
    if (message.StatusCode === 200) {
      Logger.Trace("[Strategies_Api_Response][GetRecordCallPermission] GetRecordCallPermission =>", message);
      sharedData.setAllowMarksPermission(json.Response !== 3);
    }
  },
}



// WEBPACK FOOTER //
// ./src/js/Strategies/Strategies_Api_Response.js